export default "__VITE_ASSET__DCVJAxsW__"